export const HOME = "/";
export const BATTLES = "battles";
export const BATTLE = "battles/weekly/:id";
export const WALLET = "wallet";
export const LEADERBOARD = "leaderboard";
export const PROFILE = "profile";
export const TRADE = "trade";
